import { NavLink, Link } from 'react-router-dom'
import { cn } from '@/lib/utils'
import {
  LayoutDashboard,
  Table2,
  BarChart3,
  Bell,
  Wallet,
  ArrowLeftRight,
  Settings,
  LogOut,
} from 'lucide-react'
import { useAuth } from '@/contexts/AuthContext'

const navItems = [
  { title: 'Visão Geral', href: '/gestor', icon: LayoutDashboard, end: true },
  { title: 'Detalhamento', href: '/gestor/detalhamento', icon: Table2, end: false },
  { title: 'Realizado × Orçado', href: '/gestor/realizado-orcado', icon: BarChart3, end: false },
  { title: 'Alertas (>80%)', href: '/gestor/alertas', icon: Bell, end: false },
  { title: 'Verbas adicionais', href: '/gestor/verbas-adicionais', icon: Wallet, end: false },
  { title: 'Movimentações', href: '/gestor/movimentacoes', icon: ArrowLeftRight, end: false },
]

export function GestorSidebar() {
  const { signOut } = useAuth()

  return (
    <div className="flex h-screen w-64 shrink-0 flex-col border-r border-[#131E29]/10 bg-white">
      {/* Identidade Solis */}
      <div className="bg-white px-4 pt-6 pb-2 flex justify-center">
        <img
          src="/logo-solis-light.png"
          alt="Solis Investimentos"
          className="h-12 w-auto object-contain"
        />
      </div>

      {/* Navigation */}
      <div className="flex-1 overflow-auto py-6 px-4">
        <div className="space-y-1">
          <p className="px-2 text-xs font-semibold text-slate-400 uppercase tracking-wider mb-4">
            Menu Principal
          </p>
          {navItems.map((item) => (
            <NavLink
              key={item.href}
              to={item.href}
              end={item.end}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-all',
                  isActive
                    ? 'bg-orange-50 text-[#131E29] border-l-[3px] border-orange-500 pl-[9px]'
                    : 'text-slate-600 hover:bg-[#F8F9FA] hover:text-[#131E29] border-l-[3px] border-transparent pl-[9px]'
                )
              }
            >
              <item.icon className="h-5 w-5 shrink-0" />
              {item.title}
            </NavLink>
          ))}
        </div>
      </div>

      {/* Bottom Actions */}
      <div className="border-t p-4 space-y-2">
        <Link
          to="/dashboard"
          className="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-slate-500 hover:bg-slate-50 hover:text-slate-900 transition-all"
        >
          <Settings className="h-5 w-5 text-slate-400" />
          Painel Admin
        </Link>
        <button
          onClick={signOut}
          className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-slate-500 hover:bg-red-50 hover:text-red-600 transition-all"
        >
          <LogOut className="h-5 w-5 text-slate-400" />
          Sair
        </button>
      </div>
    </div>
  )
}
